'use client'

import React, { useEffect } from 'react'
import '../../sass/menu/AdSection.scss'

const AdComponent: React.FC = () => {
  useEffect(() => {
    const initializeAds = () => {
      if (typeof window !== 'undefined') {
        const script = document.createElement('script')
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7899330733060299'
        script.crossOrigin = 'anonymous'
        script.async = true
        document.body.appendChild(script)

        script.onload = () => {
          try {
            ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({})
          } catch (error: any) {
            console.log(error.message)
          }
        }
      }
    }

    initializeAds()
  }, [])

  return (
    <div className='ad-section'>
      <ins
        className='adsbygoogle'
        style={{ display: 'block' }}
        data-ad-client='ca-pub-7899330733060299'
        data-ad-slot='1218233736'
        data-ad-format='auto'
        data-full-width-responsive='true'
      />
    </div>
  )
}

export default AdComponent
